import { render, staticRenderFns } from "./MaskRedirectButton.vue?vue&type=template&id=10c79bbc&scoped=true&"
import script from "./MaskRedirectButton.vue?vue&type=script&lang=js&"
export * from "./MaskRedirectButton.vue?vue&type=script&lang=js&"
import style0 from "./MaskRedirectButton.vue?vue&type=style&index=0&id=10c79bbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c79bbc",
  null
  
)

export default component.exports